import { Button, Card, Page, Text } from "@shopify/polaris"
import React from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { useIntercom } from "react-use-intercom"

import { Container } from "@/component"
import CardTitle from "@/component/TitleGroup/CardTitle"
import CourierMatching from "@/pages/Settings/components/CourierMatching"

const CarrierMatching = () => {
  const { t } = useTranslation("orders")
  const { t: commonT } = useTranslation("common")
  const navigate = useNavigate()

  const handleBackClick = () => {
    navigate({ pathname: "/orders" })
  }

  const intercom = useIntercom()

  const contactUS = () => {
    intercom.showNewMessage(t("NeedSupportMessage"))
  }

  return (
    <Container maxWidth={"950px"} className={"mt-0"} fullWidth={false}>
      <Page
        title={t("CarrierMatching")}
        backAction={{
          onAction: handleBackClick,
        }}
      >
        <div className={"flex flex-wrap gap-5 mb-5"}>
          <div className={"w-[620px] max-w-full"}>
            <CourierMatching />
          </div>
          <div className={"flex-1"}>
            <Card>
              <CardTitle title={t("NeedHelp")} />
              <div className={"mt-1"}>
                <Text as={"span"} tone={"subdued"}>{t("NeedHelpDesc")}</Text>
              </div>
              <div className={"mt-4"}>
                <Button onClick={contactUS}>{commonT("ContactUs")}</Button>
              </div>
            </Card>
          </div>
        </div>
      </Page>
    </Container>
  )
}

export default CarrierMatching
